'use client'
import React, {useCallback} from "react";
import styled from "styled-components";
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {Img} from "@/components/Img";
import useDeviceTypeMobile from "@/components/hooks/useDeviceTypeMobile";
import Slider, {Slide} from "@/components/swiper";
import ThemeContainer from "@/components/theme/container";
import SweeperNav from "@/components/swiper/SweeperNav";
import {Container} from "react-bootstrap";
import SliderItem from "@/components/home/single/SliderItem";
import useViewportHeight from "@/components/hooks/useViewportHeight";

const prevB = ` <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
<circle cx="20" cy="20" r="19.5" />
<path class="path" fill-rule="evenodd" clip-rule="evenodd" d="M19.6483 27.8572C19.8435 28.0525 20.1601 28.0525 20.3554 27.8572C20.5506 27.662 20.5506 27.3454 20.3554 27.1501L13.7071 20.5018L27.5037 20.5018C27.7798 20.5018 28.0037 20.278 28.0037 20.0018C28.0037 19.7257 27.7798 19.5018 27.5037 19.5018L13.7071 19.5018L20.3554 12.8536C20.5506 12.6583 20.5506 12.3417 20.3554 12.1464C20.1601 11.9512 19.8435 11.9512 19.6483 12.1464L12.1464 19.6483C12.097 19.6977 12.06 19.755 12.0356 19.8161C12.0179 19.8605 12.0068 19.9069 12.0023 19.9539C12.0008 19.9698 12 19.9858 12 20.0018C12 20.0018 12 20.0018 12 20.0018C12 20.0194 12.0009 20.037 12.0028 20.0545C12.0073 20.0979 12.0175 20.1407 12.0334 20.1819C12.0578 20.2451 12.0954 20.3044 12.1464 20.3554L19.6483 27.8572Z" 
fill="#ffffff"/>
</svg>`
const nextB = `<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40' fill='none'>
                      <circle cx='20' cy='20' r='19.5' />
                      <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M20.3554 12.1464C20.1601 11.9512 19.8435 11.9512 19.6483 12.1464C19.453 12.3417 19.453 12.6583 19.6483 12.8536L26.2966 19.5018H12.5C12.2239 19.5018 12 19.7257 12 20.0018C12 20.278 12.2239 20.5018 12.5 20.5018H26.2966L19.6483 27.1501C19.453 27.3454 19.453 27.662 19.6483 27.8572C19.8435 28.0525 20.1601 28.0525 20.3554 27.8572L27.8572 20.3554C27.9067 20.3059 27.9436 20.2487 27.968 20.1876C27.9877 20.1383 27.9999 20.0852 28.0029 20.0297C28.0034 20.0204 28.0037 20.0111 28.0037 20.0018C28.0037 19.9874 28.0031 19.973 28.0018 19.9587C27.9978 19.9121 27.9873 19.866 27.9703 19.8218C27.9459 19.7585 27.9082 19.6993 27.8572 19.6483Z'
                          fill='#ffffff'
                          class="path"
                      />
                 </svg>`

const Banner = ({data}) => {

    const interleaveOffset = 0.5;
    const isMobile = useDeviceTypeMobile()
    // Call the custom hook to apply the viewport height logic
    useViewportHeight();



    // handle slider progress
    const handleProgress = useCallback((swiper) => {
        swiper.slides.forEach((slide) => {
            const slideProgress = slide.progress;
            const innerOffset = swiper.width * interleaveOffset;
            const innerTranslate = slideProgress * innerOffset;
            slide.querySelector(".slide-inner").style.transform = `translate3d(${innerTranslate}px, 0, 0)`;
        });
    }, [interleaveOffset]);


    // Handle slide transition
    const handleSetTransition = useCallback((swiper, speed) => {
        swiper.slides.forEach((slide) => {
            slide.style.transition = `${speed}ms`;
            slide.querySelector(".slide-inner").style.transition = `${speed}ms`;
        });
    }, [data]);





    return (
        <StyledBanner className={'home-banner parallax'}>
            {
                data?.length > 0 &&
                <Container>
                    <div className="sweeper-nav">
                        <SweeperNav
                            prevSvg={prevB}
                            prevId={'parenting-next'}
                            nextSvg={nextB}
                            nextID={'parenting-prev'}
                            borderColor="#ffffff"
                        />
                    </div>
                </Container>
            }


            {
                data?.length > 0 &&
                <Slider
                    modules={[Autoplay, Pagination, Navigation]}
                    spaceBetween={0}
                    autoplay={{
                        delay: 7000,
                    }}
                    speed='3000'
                    onProgress={handleProgress}
                    onSetTransition={handleSetTransition}
                    grabCursor={false}
                    loop={true}
                    watchSlidesProgress={true}
                    mousewheelControl={true}
                    keyboardControl={true}
                    navigationRight={'.parenting-next'}
                    navigationLeft={'.parenting-prev'}
                    navigation={{
                        prevEl: '.parenting-prev',
                        nextEl: '.parenting-next',
                    }}
                    pagination={false}
                    className="mySwiper"
                >

                    {
                        data && data?.length > 0 &&
                        data?.map((e, index) => {
                            return (
                                <Slide key={index}>
                                    <div className="slide-inner">
                                        {
                                            isMobile ?
                                                <Img parallax src={e?.m_image ? e?.m_image : e?.image}/>

                                                :
                                                <Img parallax src={e?.image}/>
                                        }
                                        <ThemeContainer columns={1} colProps={{md: 7, xs: 10}}>
                                            {e?.title && <SliderItem title={e?.title}/>}
                                        </ThemeContainer>
                                    </div>
                                </Slide>
                            )
                        })
                    }

                </Slider>
            }

        </StyledBanner>
    );
};

const StyledBanner = styled.section`
  position: relative;
  overflow: hidden;
  height: 100svh;
  .home-banner {
    .container {
      position: relative;
    }

  }

  .sweeper-nav {
    position: absolute;
    right: 8%;
    top: 80%;
    z-index: 999;
  }

  .swiper-button-prev, .swiper-button-next {
    display: none;
  }

  .swiper-slide {
    overflow: hidden;

  }

  .swiper-slide-active {
    .slide-inner {
      &__info {
        h1 {
          transform: translateY(0px);
        }

        .dc-btn {
          transform: translateY(0px);
        }
      }

    }
  }

  .swiper {
    position: relative;
  }

  .slide-inner {
    position: relative;
    height: 100svh;

    .container {
      position: absolute;
      left: 0;
      right: 0;
      z-index: 2;

      /* Modified positioning for better iOS compatibility */
      top: 75%;
      transform: translateY(-50%);

      /* Force hardware acceleration */
      transform: translate3d(0, -50%, 0);
      -webkit-transform: translate3d(0, -50%, 0);

      /* Force a new stacking context */
      will-change: transform;

      /* Ensure the container is rendered */
      display: block;

      /* Force iOS to recognize the container */
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
    }


  }


  //responsive
  @media (max-width: 767px) {
    .slide-inner {
      .container {
        position: fixed;  /* Change to fixed for iOS */
        top: auto !important;
        bottom: 150px;
        left: 0;
        right: 0;
        transform: none;
        -webkit-transform: none;
      }
    }

    .navigation {
      bottom: 30px;
      left: 50%;
      right: unset;
      transform: translateX(-50%);
      margin-left: 15px;

    }

    .sweeper-nav {
      left: 0;
      top: 90%;
      right: unset;
      transform: translate(40px, 15px);
    }
  }
`;

export default React.memo(Banner);
